import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Configure, connectSearchBox, InstantSearch, Stats,} from 'react-instantsearch-dom';
import qs from 'qs'
import {withRouter} from 'react-router'
import {Link as RouterLink} from "react-router-dom";
import _map from 'lodash/map'
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import clsx from "clsx";
/*constants*/
import {autocompleteHits, ProductListHitsPerPage} from "../CarsListPage/constants";
import {PAGES_SLUGS} from "../../constants";
import {
    nonEmptySearchClient,
    indexName,
    searchClient,
    sortItems
} from "../../constants/algolia";
/*actions*/
import * as actions from "../CarsListPage/actions";
/*ui*/
import {withStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Icon from "@material-ui/core/Icon";
/*components*/
import AlgoliaSortByMobile from "../../components/ContentBlocks/Cars/AlgoliaSortByMobile";
import AlgoliaSortByDesktop from "../../components/ContentBlocks/Cars/AlgoliaSortByDesktop";
import AlgoliaHits from "../../components/ContentBlocks/Cars/AlgoliaHits";
import AlgoliaPagination from "../../components/ContentBlocks/Cars/AlgoliaPagination";
import AlgoliaAutoComplete from "../../components/ContentBlocks/Cars/AlgoliaAutoComplete";
import AlgoliaFiltersMobile from "../../components/ContentBlocks/Cars/AlgoliaFiltersMobile";
import filterStyles from "../../theme/filterStyles";
import listingStyles from "../../theme/listingGeneralStyles";
import TopSection from '../../components/ContentBlocks/Cars/TopSection';
import CarCategoryFilter from '../../components/ContentBlocks/Cars/CarCategoryFilter';
/*helpers*/
import extractFilterName from "../../helpers/extractFilterName";
import {availabilityOffset, getYearAndWeek} from "../../helpers/inStock";
import RenderCarFilters from "../../components/Algolia/RenderCarFilters";
import {appStyle} from "../../theme/appStyle";
import TopSectionFaraRabla from "../../components/ContentBlocks/Rabla/TopSectionFaraRabla";
import AlgoliaSortByDesktopRabla from "../../components/ContentBlocks/Rabla/AlgoliaSortByDesktopRabla";
import RenderCarFiltersRabla from "../../components/Algolia/RenderCarFiltersRabla";
import AlgoliaSortByMobileRabla from "../../components/ContentBlocks/Rabla/AlgoliaSortByMobileRabla";
import AlgoliaHitsRabla from "../../components/ContentBlocks/Rabla/AlgoliaHitsRabla";
import AlgoliaPaginationRabla from "../../components/ContentBlocks/Rabla/AlgoliaPaginationRabla";


const VirtualSearchBox = connectSearchBox(() => null);

/**
 * ms until the URL updates. This is required for performance so there won't be too many pushes on filtering
 * @type {number}
 */
const ulrDebounceTimer = 200;

const availabilityNames = {
    immediate: 'immediate',
    soon: '4-weeks',
    later: '8-weeks'
}

const customStyles = theme => ({
    ...appStyle(theme),
    ...filterStyles(theme),
    ...listingStyles(theme),
    listingContainer: {
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0, 1),
        },
        padding: theme.spacing(0, 2),
    },
    dealerHeaderAlign: {
        [theme.breakpoints.between('md', 'lg')]: {
            flexWrap: 'nowrap',
            justifyContent: 'space-between'
        },
    },
    filterContainer: {
        [theme.breakpoints.up('md')]: {
            paddingRight: theme.spacing(2),
        },
        [theme.breakpoints.up('xl')]: {
            paddingRight: theme.spacing(2),
        }
    },
    filterPadding: {
        borderRadius: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: `rgba(255, 255, 255, 0.1)`,
    },
    rablaContainer: {
        backgroundColor: `#244191`,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2),
        height: `100%`
    },
    hitsContainer: {
        borderRadius: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: `#fff`,
        minHeight: `25rem`,
    },
    usedCarAttributes: {
        maxWidth: "360px",
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%"
        },
    },
    sortButton: {
        ...filterStyles(theme).sortButton,
        backgroundColor: `rgba(255, 255, 255, 0.1)`
    },
    searchBarContainer: {
        marginBottom: theme.spacing(2),
    },
    stickySort: {
        ...listingStyles(theme).stickySort,
        paddingLeft: theme.spacing(2),
    },
    paginationGrid: {
        ...listingStyles(theme).paginationGrid,
        marginTop: theme.spacing(2),
    }
});

class CarListingFaraRabla extends Component {
    state = {
        openFilterDialog: false,
        openFilterSideMenu: false,
        searchState: {
            query: this.props.defaultQuery
        },
        facets: {},
        openSearchDialog: false,
    };

    componentDidMount() {
        this.fetchDynamicFacets();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        /**
         * Update the state when clicking the bottom navigation button
         * Or when using See all in autocomplete
         */
        if (this.props.location.search !== prevProps.location.search) {
            this.setState({ searchState: this.urlToSearchState(this.props.location) })
        }

        /**
         * Save the facets we get from Algolia in this.state with key: value
         * extractFilterName: Algolia-facet-name; ex.: category: category.name
         * This is required when encoding and decoding the URLs
         */
        // console.log('this.props.facets', this.props.facets);
        if (_isEmpty(this.state.facets) && this.props.facets.length !== 0) {
            const facetNameSync = {};
            this.props.facets.map((facet) => {
                facetNameSync[extractFilterName(facet)] = facet
            })
            // console.log('facetNameSync', facetNameSync);
            this.setState({
                facets: {
                    ...facetNameSync
                },
            }, () => {
                /**
                 * Because we have dynamic facets, we need those to convert the URL to search state
                 * This is why the searchState is empty and not initialized on mount
                 */
                this.setState({ searchState: this.urlToSearchState(this.props.history.location) })
            })
        }
    }

    fetchDynamicFacets = () => {
        this.props.fetchFacets();
    };

    handleFiltersDialog = () => {
        this.setState({ openFilterDialog: !this.state.openFilterDialog });
    };

    onSearchStateChange = searchState => {
        // console.log(this.searchStateToUrl(this.props.location.pathname, searchState));
        // console.log('searchState',searchState);

        clearTimeout(this.debouncedSetState);

        this.debouncedSetState = setTimeout(() => {
            this.props.history.push(this.searchStateToUrl(this.props.history.location.pathname, searchState),
                searchState)
        }, ulrDebounceTimer);

        this.setState({ searchState });
    };

    /* SNOWPLOW - track searchbar input*/
    handleSearchStateChange = ({ query }) => {
        if (query && query !== "") {
            // If there's a query and it's not an empty string, track it with Snowplow
            if (window.snowplow) {
                window.snowplow('trackSiteSearch', {
                    terms: [query],
                });
            }
        }
    };

    createURL = state => {
        const noFacetsSelected = () => {
            if (_isEmpty(state.refinementList)) return true
            return Object.values(state.refinementList).every(item => item === '');
        }

        const noPriceRangeSelected = () => {
            if (!state.range) return true
            return _get(
                    state.range, 'client_invoice_price.min', '') === ''
                && _get(state.range, 'client_invoice_price.max', '') === '';
        }

        const noArrivalSegmentRangeSelected = () => {
                if (!state.range) return true
                return (_get(state.range, 'arrival_date_segment.min', '') === ''
                    && _get(state.range, 'arrival_date_segment.max', '') === ''
                );
            }

        const isDefaultRoute =
            // No query string
            !state.query
            // First page
            && state.page === 1
            // All facets are empty arrays or none exists
            && noFacetsSelected()
            // No sorting
            && (!state.sortBy || state.sortBy === indexName)
            // Price input values
            && noPriceRangeSelected()
            && noArrivalSegmentRangeSelected()

        // Not used; fully replaced this mechanics with custom input values
        // No numeric filtering
        // && !state.multiRange

        if (isDefaultRoute) {
            return '';
        }

        const queryParameters = {};

        if (state.query) {
            queryParameters.query = state.query;
        }
        if (state.page !== 1) {
            queryParameters.page = state.page;
        }
        if (state.sortBy) {
            const sorting = state.sortBy.replace(`${indexName}_`, "");
            /**
             * indexName is the unsorted index
             * indexName + '_sort_type'
             * Equal if there is no sort
             */
            if (sorting !== indexName) {
                queryParameters.sortBy = sorting;
            }
        }

        /**
         * Process the refinements if any
         * FaraRabla has car_type_categories=Ecobonus
         */
        if (state.refinementList) {
            // console.log('state.refinementList', state.refinementList);
            for (let [key, value] of Object.entries(state.refinementList)) {
                if (key === 'car_type_categories') continue;
                if (value) {
                    queryParameters[extractFilterName(key)] = value;
                }
            }
        }
        console.log("queryParameters", queryParameters);

        /**
         * Process the price inputs
         */
        if (!noPriceRangeSelected()) {
            const priceRange = state.range.client_invoice_price;
            // console.log(priceRange);
            if (!priceRange.min && priceRange.max) {
                /// If there's only a max value
                queryParameters.price = `0:${priceRange.max}`
            } else if (priceRange.min && !priceRange.max) {
                /// If there's only a min value
                queryParameters.price = `${priceRange.min}`
            } else {
                /// If both values are present
                queryParameters.price = `${priceRange.min}:${priceRange.max}`
            }
        }

        /**
         * Process the availability options
         * Check AvailabilityInput component for details
         */
        if (!noArrivalSegmentRangeSelected()) {
            const arrivalSegment = state.range.arrival_date_segment;

            if (arrivalSegment.max === getYearAndWeek(availabilityOffset.now.end)) {
                queryParameters.availability = availabilityNames.immediate
            } else if (arrivalSegment.max === getYearAndWeek(availabilityOffset.soon.end)) {
                queryParameters.availability = availabilityNames.soon
            } else {
                queryParameters.availability = availabilityNames.later
            }
        }

        // qs.stringify encodes the URL
        // No need to use encodeURIComponent on any value
        const queryString = qs.stringify(queryParameters, {
            addQueryPrefix: true,
            arrayFormat: 'repeat',
        });

        return `${queryString}`;
    };

    searchStateToUrl = (pathname, searchState) => {
        console.log('searchStateToUrl', searchState);
        return searchState ? `${pathname}${this.createURL(searchState)}` : '';
    }

    urlToSearchState = location => {
        const queryParameters = qs.parse(location.search.slice(1));
        const { query = '', page = 1, price = '', availability = '', inStock = false } = queryParameters;
        const sortBy = queryParameters.sortBy ? `${indexName}_${queryParameters.sortBy}` : indexName
        const refinementList = {};
        const range = {};

        /**
         * Parse the facets and see if there are any in refinementList
         */
        // console.log('refinementList', refinementList);
        _map(Object.keys(queryParameters), (parameter) => {
            if (this.state.facets[parameter]) {
                // console.log(parameter, 'in Alogilia is', this.state.facets[parameter]);
                /**
                 * All values in refinementList must be arrays even if it contains a single element
                 */
                refinementList[this.state.facets[parameter]] = Array.isArray(queryParameters[parameter]) ? queryParameters[parameter] : [queryParameters[parameter]].filter(Boolean)
            }
        })

        /**
         * Change this if price URL notation changes
         * Current:
         * valMin:valMax
         * valMin:
         * Need to check if the priceRange from the url contains one element
         */
        if (price !== '') {
            const priceRange = price.split(':');
            console.log('priceRange urlToSearchState', priceRange);
            /**
             * Mechanics is similar to multiRange
             * Moved the refining logic to InputMenu
             */

            if (priceRange.length === 1) {
                // console.log(`priceRange.length ${priceRange.length}`);
                /**
                 * If the greaterThan numericMenu was selected
                 * of if the InputMenu has only min value
                 * ["75000"]
                 */
                range.client_invoice_price = { min: priceRange[0] }
            } else if (priceRange[0] === '0') {
                // console.log(`priceRange[0] ${priceRange[0]}`);
                /**
                 * If the lowerThan numericMenu was selected
                 * of if the InputMenu has only max value
                 * ["0", "40000"]
                 */
                range.client_invoice_price = { max: priceRange[1] }
            } else {
                // console.log(`${priceRange[0]}-${priceRange[1]}`);
                /**
                 * If interval was selected in the numericMenu
                 * of if the InputMenu has both min and max values
                 * ["28000", "42000"]
                 */
                range.client_invoice_price = { min: priceRange[0], max: priceRange[1] }
            }
        }

        /**
         * We map the inStock flag to current available and ignore any possible availability queries
         * inStock=true is identical to availability=immediate
         */
        if (inStock) {
            range.arrival_date_segment = { max: getYearAndWeek(availabilityOffset.now.end) }
        } else if (availability !== '') {
            if (availability === availabilityNames.immediate) {
                range.arrival_date_segment = { max: getYearAndWeek(availabilityOffset.now.end) }
            } else if (availability === availabilityNames.soon) {
                range.arrival_date_segment = { max: getYearAndWeek(availabilityOffset.soon.end) }
            } else if (availability === availabilityNames.later) {
                range.arrival_date_segment = { max: getYearAndWeek(availabilityOffset.later.end) }
            }
        }

        /**
         * FaraRabla has car_type_categories=Ecobonus
         */
        return {
            query: query,
            page,
            sortBy: sortBy,
            refinementList: {
                ...refinementList,
                car_type_categories: ['Ecobonus']
            },
            range: {
                ...range
            }
        };
    };

    render() {
        const { classes } = this.props
        return (
            <Grid container alignContent={"stretch"} className={classes.listingContainer}>
                {(_isEmpty(this.state.facets)) ? (
                    <Box
                        width={"100%"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}>
                        <CircularProgress size={24} />
                    </Box>
                ) : (
                    <InstantSearch indexName={indexName}
                                   searchClient={searchClient}
                                   onSearchStateChange={this.onSearchStateChange}
                                   searchState={this.state.searchState}
                                   createURL={this.createURL}
                    >

                        <Grid item xs={12}>
                            <TopSectionFaraRabla />
                        </Grid>

                        <Grid container className={classes.rablaContainer}>
                        <Grid item xs={12} className={classes.searchBarContainer}>
                            <Grid container alignItems="center">
                                <Grid item sm={6} xs={false} className={`${classes.searchSubtitle} ${classes.hiddenSmDown}`}>
                                    <Typography variant={"subtitle2"} className={`${classes.weight300} ${classes.whiteText}`}>
                                        <Stats
                                            translations={{
                                                stats(nbHits) {
                                                    return nbHits === 1
                                                        ? `Lista cuprinde ${nbHits} mașină.`
                                                        : `Lista cuprinde ${nbHits} mașini.`;
                                                },
                                            }}
                                        />
                                    </Typography>
                                </Grid>
                                <Grid item xl={6} lg={6} md={6} xs={12}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}
                                              className={`${classes.mobileFilterParent} ${classes.hiddenMdUp}`}>
                                            <Button
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                aria-describedby="filterToggle"
                                                onClick={this.handleFiltersDialog}
                                                className={`${classes.sortButton} ${classes.sortWidth}`}
                                            >
                                                <Typography variant={"body1"}
                                                            className={`${classes.weight300} ${classes.sortButtonText}  ${classes.whiteText}`}><Icon
                                                    className={`${classes.iconRightMargin} ${classes.whiteText} brand-icon-filter`} />Filtrează</Typography>
                                                <Icon className={`${classes.sortIcon} ${classes.whiteText} brand-icon-down-arrow`} color={"primary"}/>
                                            </Button>
                                        </Grid>
                                        <AlgoliaFiltersMobile
                                            facets={this.props.facets}
                                            open={this.state.openFilterDialog}
                                            onClose={this.handleFiltersDialog}
                                            onSearchStateChange={this.onSearchStateChange}
                                            searchState={this.state.searchState}
                                            isDealerPage={this.props.isDealerPage}
                                        />
                                        <Grid container item xs={6} md={12} alignItems="center" justify="flex-end"
                                              className={`${classes.sortParent} ${classes.hiddenXlUp}`}>
                                            <AlgoliaSortByMobileRabla
                                                defaultRefinement={indexName}
                                                items={sortItems}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xl={2} lg={3} md={3}
                              className={`${classes.filterContainer} ${classes.hiddenSmDown}`}
                        >
                            <Grid item className={`${classes.filterPadding}`}
                            >
                                <VirtualSearchBox defaultRefinement={this.state.searchState.query} />
                                {/*This creates a clickable link which adds the `menu` object to the search state*/}
                                {/*<Menu attribute="categories.name" />*/}

                                <Typography variant={"body1"}
                                            className={`${classes.weight300} ${classes.whiteText}`}>
                                    Filtrează după specificații:
                                </Typography>
                                <RenderCarFiltersRabla
                                    facets={this.props.facets}
                                    isDealerPage={this.props.isDealerPage}
                                />
                                <Configure hitsPerPage={ProductListHitsPerPage} />
                            </Grid>
                        </Grid>

                        <Grid item xl={8} lg={9} md={9} sm={12} xs={12}>
                            <Box className={classes.hidden}>
                                <CarCategoryFilter attribute="car_type_categories" />
                            </Box>
                            <Grid className={classes.hitsContainer}>
                                <Grid container spacing={2}>
                                    <AlgoliaHitsRabla />
                                </Grid>
                            </Grid>

                            <Grid container justify={"center"}
                                  className={`${classes.paginationGrid} ${classes.relative}`}>
                                <AlgoliaPaginationRabla
                                    showPrevious={true}
                                    showNext={true}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xl={2} className={`${classes.hiddenLgDown} ${classes.stickySort}`}>
                            <Grid item className={`${classes.filterPadding}`}
                            >
                                <AlgoliaSortByDesktopRabla
                                    defaultRefinement={indexName}
                                    items={sortItems}
                                />
                            </Grid>
                        </Grid>
                        </Grid>
                    </InstantSearch>
                )}
            </Grid>
        )
    };
}

function mapStateToProps(state) {
    return {
        location: state.router.location,
        facets: state.cars.facets.data,
    }
}

CarListingFaraRabla = withRouter(CarListingFaraRabla);
CarListingFaraRabla = withStyles(customStyles)(CarListingFaraRabla);
CarListingFaraRabla = connect(mapStateToProps, { ...actions })(CarListingFaraRabla);

export default CarListingFaraRabla;
